import React, {useEffect,useState,useRef} from 'react';
import {FormValidator, useFormValidator, Inputs, TextArea} from 'coaz-ui';
import client from '../client';
import { LiaPlusSolid } from 'react-icons/lia';
import { PiTrashLight } from 'react-icons/pi';

const AddProgram = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [program,setProgram] = useState({professionalCategories:[]});
    const [addingProfessionalCategory,setAddingProfessionalCategory] = useState(false);
    const [selectedProfessionalCategory,setSelectedProfessionalCategory] = useState(null);
    const [addProfessionalCategory,setAddProfessionalCategory] = useState(null);
    const [criteriaPaths,setCriteriaPaths] = useState([]);
    const minWidth = 240;
    const {request,errorMessage} = client;
    const addButtonRef = useRef(null);

    const submit = async (e) => {
        try {
            const response = await request('POST', 'programs', program);

            if (response && response.ref) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const inputs = [
        {
            label:'Name',
            type:'text', 
            name:'name',
            value:program && program.name?program.name:'',   
            placeholder:'Enter name...',
            onChange:(e) => {handleChange(e,onChange)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'External Id',
            type:'number', 
            name:'externalId',
            value:program && program.externalId?program.externalId:'',   
            placeholder:'Enter external id...',
            onChange:(e) => {handleChange(e,onNumber)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Tariff Applicable',
            type:'checkbox',
            name:'tariffApplicable',
            value:program?program.tariffApplicable:false,   
            onChange:(e) => {
                setProgram({...program,tariffApplicable: !program.tariffApplicable});
            }
        },
        {
            label:'Criteria paths',
            type:'select',
            options:() => {
                let options = [];
                program && program.tariffApplicable && criteriaPaths.map((option,i) => options.push(<option key={i} value={option.id}>{option.id}</option>));
                return options;
            },
            name:'criteriaPathItem', 
            value:program && program.criteriaPathItemId?program.criteriaPathItemId:'',
            disabled:program && !program.tariffApplicable,
            onChange:(e) => handleChange(e,onCriteriaPath)
        }
    ]

    const onChange = (e) => {
        const value = e.target.value;
        if(value === '') {
          setProgram({...program, [e.target.name]: null});
        } else {
          setProgram({...program, [e.target.name]: value});
        }
    }

    const onNumber = (e) => {
        const value = e.target.value;
        if(isNaN(value)) {
            return;
        }
        if(value === '' && value) {
          setProgram({...program, [e.target.name]: null});
        } else {
          setProgram({...program, [e.target.name]: value});
        }
    }

    const onCriteriaPath = (e) => {
        if(e.target.value === '') {
            setProgram({...program, criteriaPathItemId: null});
        } else {
            let value = criteriaPaths.find((path) => {return path.id == e.target.value});
            setProgram({...program, criteriaPathItemId: value.id});
        }
    }

    const add = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setAddingProfessionalCategory(true);
        if(addButtonRef.current) {
            let maxHeight = 200;
            let padding = 0;
            let itemHeight = 32;
            let avaiProfessionalCategories = [];
            await request('GET','professional-categories')
            .then((response) => {
                if(response && response.length > 0) {
                    for(let professionalCategory of response) {
                        if(!program.professionalCategories.find((programProfessionalCategory)=>{return programProfessionalCategory == professionalCategory})) {
                            avaiProfessionalCategories.push(professionalCategory);
                        }
                    }
                }
            })
            .catch((error) => {
                console.log(error.message);
            });
            let height = (padding * 2) + (avaiProfessionalCategories.length * itemHeight);
            height = height > maxHeight? maxHeight:height;
            let rect = addButtonRef.current.getBoundingClientRect();
            let vh = document.documentElement.clientHeight;
            let top = rect.bottom;
            if (rect.bottom + height > vh) {
                top = rect.top - height;
            }
            setAddProfessionalCategory({Component:() => 
                <div onClick={e => e.stopPropagation()} 
                    style={{left:rect.left+'px',top:top+'px',height:height+'px',paddingTop:padding+'px',paddingBottom:padding+'px'}} 
                    className='fixed flex flex-col w-fit shadow-lg bg-[rgb(238,238,238)] overflow-y-auto'>
                    {avaiProfessionalCategories.map((professionalCategory,i) => 
                        <div key={i} 
                            onClick={(e) => {
                                let programProfessionalCategories = program.professionalCategories;
                                programProfessionalCategories.push(professionalCategory);
                                setProgram({...program,professionalCategories:programProfessionalCategories});
                                setAddProfessionalCategory(null);
                                setAddingProfessionalCategory(false);
                            }} 
                            style={{height:itemHeight+'px'}} 
                            className='flex w-full shrink-0 items-center font-jostBook text-sm text-[rgb(93,93,93)] hover:text-white hover:bg-[rgb(0,175,240)] cursor-pointer'>
                                <p className='px-8'>{professionalCategory}</p>
                        </div>
                    )}
                </div>
            });
        }
    }

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        setLoading && setLoading(true);
        request('GET','criteria-path-items')
        .then((response) => {
            if(response && response.length > 0) {
                setCriteriaPaths(response);
                setProgram({...program, criteriaPathItemId: response[0].id});
            } else {
                setCriteriaPaths([]);
            }
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            setLoading && setLoading(false);
        })
    },[]);

    return (
        <FormValidator>
            {program && <div onClick={(e) => {
                    setAddProfessionalCategory(null);
                    setAddingProfessionalCategory(false);
                }}
                className='flex flex-col w-full h-auto'>
                <div className='flex flex-col w-full h-auto shrink-0 space-y-4'>
                    <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
                    <div className='flex flex-col w-full h-auto space-y-2'>
                        <p className='text-gray-600 text-sm capitalize'>Professional Categories</p>
                        <div className='flex flex-col w-full h-auto p-4 space-y-4 border rounded-lg'>
                            {program && program.professionalCategories && program.professionalCategories.map((professionalCategory,i) => 
                            <div key={i} 
                                onClick={(e) => {
                                    setSelectedProfessionalCategory(professionalCategory); 
                                }}
                                className='flex flex-row space-x-4'>
                                <p className={`flex flex-row w-full h-auto text-sm tracking-wider whitespace-nowrap overflow-ellipsis capitalize font-jostBook ${selectedProfessionalCategory === professionalCategory?'text-[rgb(0,175,240)]':''} cursor-pointer`}>
                                    {professionalCategory}
                                </p>
                            </div>)
                            }
                        </div>
                        <div className='flex flex-row w-auto h-auto space-x-4'>
                            <button ref={addButtonRef} 
                                onClick={(e) => {
                                    add(e);
                                }} 
                                className={`flex w-6 h-6 items-center justify-center ${addingProfessionalCategory?'border border-[rgb(0,175,240)] text-[rgb(0,175,240)]':'bg-[rgb(0,175,240)] text-white hover:bg-[rgba(0,175,240,.7)]'}  rounded-sm`}>
                                <LiaPlusSolid size={16}/>
                            </button>
                            <button onClick={(e) => {
                                    e.preventDefault();
                                    let professionalCategories = program.professionalCategories.filter((programProfessionalCategory => programProfessionalCategory !== selectedProfessionalCategory));
                                    setProgram({...program,professionalCategories:professionalCategories});
                                    setSelectedProfessionalCategory(null);
                                }} 
                                disabled={!selectedProfessionalCategory}
                                className={`flex w-6 h-6 items-center justify-center ${selectedProfessionalCategory?'bg-[rgb(0,175,240)] hover:bg-[rgba(0,175,240,.7)]':'bg-[rgba(0,175,240,.7)]'} text-white rounded-sm`}>
                                <PiTrashLight size={16}/>
                            </button>
                        </div>
                    </div>
                    <TextArea
                        label='Description'
                        id='description'
                        name='description'
                        value={program.description?program.description:''}
                        placeholder='Enter description'
                        onChange={(e) => handleChange(e,onChange)}
                    /> 
                </div>
            </div>}
            {addProfessionalCategory && <addProfessionalCategory.Component/>}
        </FormValidator>
      )
}

export default AddProgram